import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useFanforgeApi } from '../providers/fanforge-api-provider';
import { Survey } from 'posthog-js';
import { getCreatorSurveyCompleted } from '@hotpot-arcade/fanforge-core/utils/surveys';
import posthog from 'posthog-js';

export const useSurvey = () => {
  const { client } = useFanforgeApi();

  const [survey, setSurvey] = useState<Survey | undefined>();

  const { data, error } = useQuery({
    queryKey: ['currentContentCreator'],
    queryFn: async () => {
      const res = await client.discord.activity.creator.current.$get();
      if (!res.ok) throw new Error('Failed to fetch creator');
      return res.json();
    },
  });

  useEffect(() => {
    if (!data) return;

    if (getCreatorSurveyCompleted(data.id, data.creatorSurveyId)) return;

    posthog.getSurveys((surveys) => {
      const matched = surveys.find((s) => s.name.includes('user-bond-survey'));
      setSurvey(matched);
    });
  }, [data]);

  return { survey, data, error };
};
